export default "__VITE_ASSET__BssQE9D8__"